export const ABOUT = "/about"
export const PLAYGROUND = "/playground"
export const SERVICES = "/services"
export const ROOT = "/"
